import type { AlignerFormData, SelectedTeeth } from '@witmetrics/utils';
import TreatmentForm from './TreatmentForm';
import ToothSelector from './ToothSelector';
import { classes } from './utils';

export type AlignersFormProps = {
  params: AlignerFormData;
  selectedTeeth: SelectedTeeth;
  onChange: (parameters: AlignerFormData, selectedTeeth: SelectedTeeth) => void;
};

export default function AlignersForm({
  params,
  selectedTeeth,
  onChange,
}: AlignersFormProps) {
  return (
    <>
      <TreatmentForm
        className={classes.form}
        data={params}
        onChange={(update) => onChange(update, selectedTeeth)}
      />
      <ToothSelector
        className={classes.form}
        value={selectedTeeth}
        onChange={(update) => onChange(params, update)}
      />
    </>
  );
}
